import { persistentReducedStream } from '@ardoq/rxbeach';
import { reducers } from './reducers';
import { getDefaultState } from './utils';
import { combineLatest, map } from 'rxjs';
import { i18nLocale$ } from 'streams/i18nLocale$';

const surveyNotUpdatedSinceCondition$ = persistentReducedStream(
  'surveyNotUpdatedSinceCondition$',
  getDefaultState(),
  reducers
);

export const surveyNotUpdatedSinceConditionViewModel$ = combineLatest([
  surveyNotUpdatedSinceCondition$,
  i18nLocale$,
]).pipe(map(([state, i18nLocale]) => ({ ...state, i18nLocale })));

export { surveyNotUpdatedSinceCondition$ };
